import React from 'react'
import TemplateFeatureForm, { TemplateFeatureFormProps } from '../TemplateFeatureForm/TemplateFeatureForm'

const TemplateSubReview = (props: TemplateFeatureFormProps) => (
  <TemplateFeatureForm data-dls="template-feature-form" {...props} />
)

export default TemplateSubReview
